import React from 'react'
import MostPopularSuperLikedSampleAndMostRecentLike from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/MostPopularSuperLikedSampleAndMostRecentLike'
import ItemsYouBothLoved from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/ItemsYouBothLoved'

export default function SquadPageCurrentFriendSampleSummaryContent () {
  return (
    <>
      <MostPopularSuperLikedSampleAndMostRecentLike />
      <ItemsYouBothLoved />
    </>
  )
}
